import { Dialog } from '@printos/vue3-dialog';
import i18n from '@/i18n'
const dialog = new Dialog(i18n);
export default dialog;
